import React from "react";

function MoreInfo() {
  return (
    <div class="alert alert-success">
    Statistics provided by<a href="https://justenergy.com/blog/how-to-calculate-your-carbon-footprint/" class="alert-link">Just energy.com</a>.
  </div>)
}

export default MoreInfo;
